import script from "./GbfsView.vue?vue&type=script&setup=true&lang=js"
export * from "./GbfsView.vue?vue&type=script&setup=true&lang=js"

import "./GbfsView.vue?vue&type=style&index=0&id=0b70b513&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b70b513"]])

export default __exports__